var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderRequestNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0626 43.75H10.9374C10.523 43.75 10.1256 43.5854 9.83261 43.2923C9.5396 42.9993 9.37499 42.6019 9.375 42.1875V7.8125C9.37499 7.39811 9.5396 7.00069 9.83261 6.70766C10.1256 6.41464 10.523 6.25001 10.9374 6.25H29.688L40.625 17.1875V42.1875C40.625 42.6019 40.4604 42.9993 40.1674 43.2923C39.8744 43.5854 39.477 43.75 39.0626 43.75V43.75Z",
    stroke: "#469473",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 6.25V17.1875H40.6266",
    stroke: "#469473",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 26.5625H31.25",
    stroke: "#469473",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 32.8125H31.25",
    stroke: "#469473",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderRequestNew);
export default __webpack_public_path__ + "static/media/Order_Request_New.cbd3efeb6b6428344f643e75d5665bf8.svg";
export { ForwardRef as ReactComponent };